(() => {
  angular
    .module('complianceFrameworkApp.vms')
    .controller('BranchesController', BranchesController);

  /* ngInject */
  function BranchesController(branchService, sessionService) {
    const vm = this;

    vm.branches = [];
    activate();

    function activate() {
      getBranches();
    }

    function getBranches() {
      branchService(sessionService.getAuthToken()).query(response => vm.branches = response);
    }
  }
})();
